webpackJsonp([105951629423537],{

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _theme = __webpack_require__(6);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookiePolicyPage = function (_React$Component) {
	    _inherits(CookiePolicyPage, _React$Component);
	
	    function CookiePolicyPage() {
	        _classCallCheck(this, CookiePolicyPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    CookiePolicyPage.prototype.componentDidMount = function componentDidMount() {
	        setTimeout(function () {
	            window.dispatchEvent(new Event("load"));
	        }, 0);
	    };
	
	    CookiePolicyPage.prototype.render = function render() {
	        var transition = this.props.transition;
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _PageDetailContainer2.default,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            _HeaderBlock2.default,
	                            {
	                                textAlign: "left",
	                                baseColor: _theme.colors.background,
	                                fontSize: 3,
	                                padding: {
	                                    top: 0.6,
	                                    right: 0,
	                                    bottom: 2.4,
	                                    left: 0
	                                }
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                "Cookie"
	                            ),
	                            " Policy"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Cookies are very small text files that are stored on your computer when you visit some websites. We use cookies to make our website easier for you to use. You can disable certain cookies on our site, but this may impact the performance of the sites we provide."
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement("div", { id: "optanon-cookie-policy" })
	                    )
	                )
	            )
	        );
	    };
	
	    return CookiePolicyPage;
	}(_react2.default.Component);
	
	exports.default = CookiePolicyPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cookie-policy-js-1aa6132d528fbeb64db0.js